export class IncrementMapper {
  constructor(protected readonly maxIncrement: number) {}

  map(increment: number): number {
    return increment;
  }
}
